import {
    type Inline,
    NODE_DATA_INVALID,
    type NodeType,
    Schema,
    type SchemaNormalizeViolationFn,
} from '@gitbook/slate';

import { BLOCK_MATH, INLINE_MATH } from '../types';
import { setFormula } from './utils';

/**
 * Schema to validate math nodes.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_MATH]: {
            isVoid: true,
            data: {
                formula: (tex) => typeof tex === 'string' && tex.trim().length > 0,
            },
        },
    },
    inlines: {
        [INLINE_MATH]: {
            isVoid: true,
            data: {
                formula: (tex) =>
                    typeof tex === 'string' && tex.trim().length > 0 && tex.indexOf('\n') < 0,
            },
            normalize: Schema.createNormalize<Inline>({
                [NODE_DATA_INVALID]: (change, { node }) => {
                    const formula = node.data.get('formula');

                    if (!formula || typeof formula !== 'string' || !formula.trim()) {
                        change.removeNodeByKey(node.key);
                    } else {
                        setFormula(change, node, formula);
                    }

                    return change;
                },
                // Cast: the normalizer is authored for the narrow `Inline` node it is
                // registered against, but the `normalize` slot is typed for the wide
                // `NodeType`. The schema only ever calls it with the matching inline.
            }) as SchemaNormalizeViolationFn<NodeType>,
        },
    },
});
